//@ts-ignore
export const policy = [
  {
    title: "ข้อกำหนดและเงื่อนไขการใช้งานแพลตฟอร์ม",
    header: "หมวดที่ 1 บททั่วไป",
    dtailList: `บริษัทกรุงเทพดุสิตเวชการ จำกัด (มหาชน) และบริษัทในเครือโรงพยาบาลกรุงเทพ ให้บริการแพลตฟอร์มแอปพลิเคชันรูปแบบโทรศัพท์เคลื่อนที่ ชื่อว่า มาย บี พลัส  ( “แพลตฟอร์ม” ) ซึ่งอยู่ภายใต้ข้อกำหนดและเงื่อนไข การเข้าใช้บริการแอพพลิเคชั่น มาย บี พลัส นี้ มีข้อกำหนดและเงื่อนไขฉบับนี้ เป็นเงื่อนไขการใช้งานแพลตฟอร์มสำหรับผู้ใช้บริการ ผู้ใช้บริการโปรดอ่านข้อกำหนดและเงื่อนไขฉบับนี้ อย่างละเอียดก่อนลงทะเบียนใช้งานแพลตฟอร์ม หากผู้ใช้บริการไม่เห็นด้วยหรือไม่ตกลงด้วยกับข้อกำหนดและเงื่อนไขฉบับนี้ โปรดระงับการลงทะเบียนการใช้งานแพลตฟอร์ม  หากผู้ใช้บริการ ลงทะเบียนใช้งานแพลตฟอร์มแล้ว จะถือว่าผู้ใช้บริการยอมรับและผูกพันตามข้อกำหนดและเงื่อนไขฉบับนี้ `,
  },
  {
    title: "",
    header: "1.คำจำกัดความ",
    dtailList: `1.1 \“บริการ\” หมายถึง บริการต่าง ๆ ที่ระบุไว้ในข้อ 2 ที่ผู้ใช้บริการสามารถเข้าถึงได้โดยผ่านทางแอพพลิเคชันมาย บี พลัส 
      1.2 \“บัญชีผู้รับบริการทางการแพทย์\” หมายถึง บัญชีที่เปิดขึ้นเพื่อประโยชน์ในการรับบริการทางการแพทย์หรือบริการอำนวยความสะดวกอื่น ๆ ซึ่งจะเชื่อมโยงเข้ากับระบบฐานข้อมูลของสถานพยาบาลต่าง ๆ ในกลุ่มโรงพยาบาลกรุงเทพ รวมถึงเวชระเบียนของผู้รับบริการที่มีอยู่กับสถาพยาบาลนั้น ๆ 1.3 \“ผู้ใช้บริการ\” หมายถึง บุคคลที่ลงทะเบียนเป็นผู้ใช้แอพพลิเคชั่น มาย บี พลัส ในนามของตนเอง ทั้งนี้ ภายใต้ข้อกำหนดและเงื่อนไขการใช้บริการนี้ 
      1.4 \“ผู้ให้บริการ\” หมายถึง บริษัท กรุงเทพดุสิตเวชการ จำกัด (มหาชน) หรือบริษัทในเครือกลุ่มโรงพยาบาลกรุงเทพ 
      1.5 \“ผู้รับบริการทางการแพทย์\” หมายถึง บุคคลที่ลงทะเบียนเป็นผู้รับบริการทางการแพทย์จากสถานพยาบาลต่าง ๆ ในกลุ่มโรงพยาบาลกรุงเทพ
      1.6 \“รหัสเข้าใช้บริการ\” หมายความถึง Login Name หรือ Username, รหัสผ่าน (Password), PIN –Person Identification Number, รหัส OTP – One Time Password รวมถึงรหัสอื่นใด หรือวิธีการยืนยันตัวบุคคลอื่นใดที่เกี่ยวข้องกับการเข้าใช้แอพพลิเคชันมาย บี พลัส ไม่ว่าจะเรียกด้วยชื่อใด ๆ และไม่ว่าจะเป็นรหัสที่ผู้ให้บริการเป็นผู้กำหนดให้หรือเป็นรหัสที่ผู้ใช้บริการเป็นผู้กำหนดเองก็ตาม 
      1.7 \“ ข้อมูลส่วนบุคคล\” หมายความว่า ข้อมูลเกี่ยวกับสิ่งเฉพาะตัวบุคคลของผู้ใช้บริการ เช่น ชื่อ นามสกุล เพศ หมายเลขประจำตัวประชาชน หมายเลขพาสปอร์ต เลขโรงพยาบาล (HN)  หมายเลขโทรศัพท์ จดหมายอิเลคโทรนิค (E-mail) ข้อมูลประวัติส่วนตัว และข้อมูลอื่น ๆ ที่มีชื่อของบุคคล เลขหมาย รหัส หรือสิ่งอื่นใดที่ทำให้รู้ตัวบุคคลนั้นได้ หรือรูปถ่ายที่มีอยู่ในระบบฐานข้อมูลของผู้ให้บริการ และ/หรือที่ผู้ให้บริการเก็บรวบรวมมาจากผู้ใช้บริการ บุคคลหรือหน่วยงานอื่นใดเพื่อประโยชน์ในการจัดการของผู้ให้บริการ ซึ่งได้รับความคุ้มครองภายใต้กฎหมายว่าด้วยการกระทำใด ๆบนเครือข่ายคอมพิวเตอร์ และกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลใด ๆ
      1.8 \“อุปกรณ์\” หมายความว่า อุปกรณ์ใด ๆ ที่นำมาใช้งานแอพพลิเคชัน มาย บี พลัสเช่น โทรศัพท์เคลื่อนที่   แท็บเล็ต คอมพิวเตอร์ หรืออุปกรณ์และเครื่องมือชนิดอื่นใดที่ผู้ให้บริการกำหนดสำหรับการใช้งานแอพพลิเคชัน มาย บี พลัส`,
    extra: {
      preLine: true,
    },
  },
  {
    title: "",
    header: "2. บริการแอพพลิเคชัน แอพพลิเคชัน มาย บี พลัส",
    dtailList: `2.1 บริการ แอพพลิเคชันแอพพลิเคชัน มาย บี พลัส ครอบคลุมการให้บริการต่าง ๆ ดังต่อไปนี้ 
      •	บริการค้นหารายชื่อแพทย์
      •	บริการนัดหมายแพทย์
      •	บริการนัดหมายตรวจสุขภาพ
      •	บริการนัดหมายฉีดวัคซีน
      •	บริการข้อมูลการรักษาผลแล็ปของผู้รับบริการทางการแพทย์
      •	บริการเอกสารใบรับรองแพทย์อิเลคโทรนิค
      •	บริการเอกสารรายงานการตรวจสุขภาพอิเลคโทรนิค
      •	บริการข้อมูลประวัติการรักษาของผู้รับบริการทางการแพทย์ย้อนหลัง 1 ปี
      •	บริการข้อมูลประวัติการรับยาผู้รับบริการทางการแพทย์
      •	บริการโทรเวชกรรม
      •	บริการชำระค่ารักษาพยาบาลและค่ายา
      •	บริการช่วยเหลือต่าง ๆ ผ่านทางแชทและการโทรศัพท์
      •	บริการบัญชีผู้รับบริการทางการแพทย์
      •	บริการบทความเชิงสุขภาพอันเกี่ยวข้องกับบริการของเครือโรงพยาบาลกรุงเทพ และสามารถส่งออกบทความดังกล่าวไปยังสื่อออนไลน์ที่ผู้ใช้บริการเลือก    
      •	บริการโทรศัพท์เรียกรถพยาบาลฉุกเฉิน หรือติดต่อกรณีฉุกเฉินอื่น ๆ
      •	บริการบันทึกการนัดหมาย
      •	บริการเชื่อมโยงผู้ใช้บริการไปยังร้านค้าหรือบริษัทที่เข้าร่วม ( Save Drug)
      •	บริการอื่น ๆ ที่อาจเพิ่มเติมในภายหลัง
      2.3 ในการให้บริการบางประเภทจำเป็นที่ผู้ใช้บริการจะต้องลงทะเบียนและล็อกอินก่อน และการใช้บริการบางประเภทอาจอยู่ภายใต้ข้อกำหนดและเงื่อนไขเพิ่มเติมเกี่ยวกับการใช้บริการนั้น ๆ ด้วย`,
  },
  {
    title: "",
    header: "3.การลงทะเบียนเป็นผู้ใช้บริการ",
    dtailList: `3.1 ท่านลงทะเบียนเป็นผู้ใช้แอพลิเคชัน มาย บี พลัส และผู้รับบริการทางการแพทย์ด้วย โดยท่านจะต้องกรอกข้อมูลส่วนตัวและตั้งรหัสประจำตัวเพื่อระบุยืนยันตัวตนของผู้ใช้ แอพลิเคชัน มาย บี พลัส
      ประเภทข้อมูลส่วนตัวประกอบด้วย
      · ข้อมูลการติดต่อ (เช่น หมายเลขประจำตัวประชาชน หมายเลขพาสปอร์ต ชื่อ-นามสกุล อีเมล ที่อยู่ปัจจุบัน และเบอร์ติดต่อ เป็นต้น)
      · ข้อมูลในการเข้าสู่ระบบเพื่อสร้างทะเบียนผู้ใช้งาน (เช่น เบอร์โทรศัพท์, อีเมล)
      3.2 ท่านจะเก็บรหัสประจำตัวไว้เป็นความลับและจะไม่เปิดเผยหรือกระทำการใด ๆ ที่อาจทำให้ผู้อื่นทราบรหัสประจำตัวดังกล่าว หากมีบุคคลอื่นล่วงรู้รหัสประจำตัวของผู้ใช้ แอพลิเคชัน มาย บี พลัส ท่านจะแจ้งให้กลุ่ม บริษัทกรุงเทพดุสิตเวชการ จำกัด (มหาชน) และบริษัทในเครือโรงพยาบาลกรุงเทพ ทราบโดยเร็ว
      3.3 ท่านสามารถเปลี่ยนแปลง Login Name หรือ Usernameb และ/หรือ รหัสผ่าน (Password) และ/หรือ PIN-Person Identification Number และ/หรือรหัสที่เกี่ยวข้องกับการเข้าใช้งาน แอพลิเคชัน มาย บี พลัส เมื่อใดก็ได้ โดยดำเนินการตามวิธีการและเงื่อนไขที่บริษัทกรุงเทพดุสิตเวชการ จำกัด (มหาชน) และบริษัทในเครือโรงพยาบาลกรุงเทพ กำหนด
      3.4 ท่านตกลงรับผิดชอบการใด ๆ ในการใช้งานแอพลิเคชัน มาย บี พลัส ที่ได้ทำผ่านรหัสประจำตัวของท่านทุกประการ`,
  },
  {
    title: "หมวดที่ 4 เงื่อนไขการใช้บริการแพลตฟอร์ม",
    header: "4.การลงทะเบียนขอเปิดบัญชีแทนบุคคลอื่นเป็นผู้รับบริการทางการแพทย์",
    dtailList: `ไม่มีการการลงทะเบียนขอเปิดบัญชีแทนบุคคลอื่น`,
  },
  {
    title: "",
    header: "5.การใช้บริการ",
    dtailList: `ผู้ใช้บริการรับทราบ ยอมรับและตกลงกับผู้ให้บริการ ดังนี้
      5.1 การใช้บริการครั้งใด ๆ ด้วยวิธีที่ใช้รหัสเข้าใช้บริการของผู้ใช้บริการผ่านแอปพลิเคชัน มาย บี พลัสให้ถือว่าเป็นการกระทำของผู้ใช้บริการเอง และมีผลผูกพันต่อผู้ใช้บริการ 
      5.2 ผู้ใช้บริการรับทราบว่าคำศัพท์เทคนิคทางการแพทย์ที่เกี่ยวกับการวินิจฉัยโรคและหัตถการนั้น เป็นคำศัพท์ภาษาอังกฤษและอาจยากต่อการทำความเข้าใจของผู้ใช้บริการ ผู้ให้บริการจะมีคำแปลคำศัพท์เทคนิคทางการแพทย์ดังกล่าว เป็นภาษาไทยและเป็นคำที่ผู้ใช้บริการสามารถเข้าใจการวินิจฉัยโรคของแพทย์และหัตถการได้ง่ายขึ้นเท่านั้น ซึ่งความหมายอาจไม่ตรงตามตัวอักษรของคำศัพท์ทางเทคนิคทางการแพทย์ หากผู้ใช้บริการมีข้อสงสัยเกี่ยวกับข้อมูลการวินิจฉัยโรค การรักษา หรือหัตถการ โปรดติดต่อสอบถามผู้ให้บริการ 
      5.3 ผู้ใช้บริการรับทราบว่าบทความเชิงสุขภาพจัดทำขึ้นเพื่อวัตถุประสงค์ในการให้ข้อมูลความรู้เป็นการทั่วไปเท่านั้น ไม่ถือเป็นคำแนะนำทางการแพทย์หรือทดแทนคำแนะนำทางการแพทย์แต่ประการใด ผู้ใช้บริการจะไม่ยึดถือข้อมูลดังกล่าว หรือเปลี่ยนแปลงหรือหยุดการรักษาพยาบาลโดยปราศจากการหารือกับแพทย์ของผู้ใช้บริการก่อน ผู้ให้บริการจะไม่รับผิดชอบในการที่ผู้ใช้บริการนำข้อมูลดังกล่าวไปใช้ในประการใด ๆ 
      5.4 ผู้ใช้บริการสามารถชำระค่ารักษาพยาบาลและค่ายาผ่าน แอปพลิเคชัน มาย บี พลัสนี้โดยผู้ใช้บริการจะต้องกรอกข้อมูลทางการเงินที่ถูกต้องครบถ้วนตามที่กำหนด ทั้งนี้ ผู้ใช้บริการในฐานะผู้ทำรายการจะต้องตรวจสอบความถูกต้องครบถ้วนของเลขที่บัญชี จำนวนเงิน และข้อมูลอื่น ๆ ด้วยตนเองก่อนเข้าทำรายการ โดยผู้ให้บริการจะไม่รับผิดชอบใด ๆ หากผู้ให้บริการได้ดำเนินการถูกต้องตามคำสั่งทำรายการของผู้ใช้บริการ 
      5.5 หากมีความผิดพลาดเกิดขึ้นเกี่ยวกับการใช้บริการ หรือมีข้อสงสัยเกี่ยวกับข้อมูลสุขภาพและอื่น ๆ ผู้ใช้บริการจะต้องแจ้งรายละเอียดต่าง ๆ ที่เกี่ยวข้องให้แก่ผู้ให้บริการ เพื่อให้ผู้ให้บริการใช้เป็นข้อมูลในการตรวจสอบข้อผิดพลาด `,
  },
  {
    title: "",
    header: "6.การจัดการและปกป้องคุ้มครองข้อมูลส่วนบุคคล",
    dtailList: `6.1 ก่อนตัดสินใจเข้ารับบริการนี้ โปรดศึกษานโยบายความเป็นส่วนตัว  (Privacy Notice) https://www.bangkokhospital.com/page/privacy-policy  อย่างไรก็ตาม ผู้ใช้บริการรับทราบว่า การส่งข้อมูลทางอินเทอร์เน็ตนั้นอาจไม่ปลอดภัย แม้ว่าผู้ให้บริการจะใช้ระบบสารสนเทศที่มีมาตรฐานและความปลอดภัยด้านสารสนเทศที่เป็นสากลก็ตาม แต่ผู้ให้บริการไม่สามารถรับรองในความปลอดภัยในข้อมูลส่วนบุคคลซึ่งผู้ใช้บริการส่งมาให้ผู้ให้บริการผ่านการใช้งานอินเทอร์เน็ต และผู้ใช้บริการจะต้องรับความเสี่ยงในการส่งข้อมูลดังกล่าวเอง 
      6.3 ถ้าผู้ใช้บริการยินยอมให้ผู้ให้บริการเปิดเผยข้อมูลของผู้ใช้บริการภายใต้เงื่อนไขและข้อกำหนดนี้ ผู้ให้บริการจะเปิดเผยข้อมูลเพียงเท่าที่จำเป็นเท่านั้น 
      6.4 โดยการใช้แอพลิเคชัน มาย บี พลัส ผู้ใช้บริการได้ยอมรับและตกลงตามนโยบายความเป็นส่วนตัว (Privacy Notice) ทุกประการ `,
  },
  {
    title: "",
    header: "7. ความรับผิดชอบของผู้ใช้บริการ",
    dtailList: `7.1 ผู้ใช้บริการจะต้องไม่อัพโหลดหรือส่งข้อมูลที่มีไวรัส โทรจัน หรือชุดคำสั่งที่มุ่งประสงค์จะรบกวน แทรกแซง ขัดขวาง หรือทำลายระบบคอมพิวเตอร์ เข้าสู่ระบบเครือข่ายคอมพิวเตอร์ของผู้ให้บริการ หรือของสถานพยาบาลต่าง ๆ ในกลุ่มโรงพยาบาลกรุงเทพ
      7.2 ผู้ใช้บริการจะไม่ทำการดังนี้ 
      (ก) คัดลอก จำแนกส่วนประกอบ ทำวิศวกรรมย้อนกลับ หรือกระทำการอื่นใดอันเป็นการเปลี่ยนแปลงทั้งหมดหรือแต่บางส่วนของแอพลิเคชัน มาย บี พลัส 
      (ข) แทรกแซงหรือขัดขวางการทำงานของซอฟต์แวร์ ระบบ อุปกรณ์ เครื่องมือ หรือเครือข่ายใด ๆ ซึ่งใช้ในบริการ หรือฝ่าฝืนกฎ ระเบียบ ข้อบังคับ นโยบายของการบริการ 
      (ค) หลีกเลี่ยงกระบวนการตรวจสอบความน่าเชื่อถือและความปลอดภัยของบริการ เครือข่าย หรือระบบอื่นใดที่เกี่ยวข้อง
       (ง) เข้าถึงและ/หรือใช้บริการโดยวิธีการอื่นใดนอกเหนือจากที่ระบุไว้ในข้อกำหนดและเงื่อนไขนี้
       (จ) ใช้บริการแอพลิเคชัน มาย บี พลัส ในลักษณะที่ขัดต่อกฎหมาย 
      (ฉ) ยินยอมให้บุคคลอื่นที่ไม่ได้รับอนุญาตจากผู้ใช้บริการใช้ ชื่อ รหัสผ่าน และกระบวนการใด ๆ เพื่อให้บุคคลดังกล่าวสามารถเข้าถึงและใช้บริการ `,
  },
  {
    title: "",
    header: "8. ข้อจำกัดความรับผิดของผู้ให้บริการ",
    dtailList: `8.1 ผู้ให้บริการจะรับผิดชอบสำหรับความเสียหายที่เกิดขึ้นในกรณีที่ผู้ให้บริการกระทำโดยจงใจ หรือประมาทเลินเล่ออย่างร้ายแรง ซึ่งเป็นความเสียหายที่ตามปกติย่อมเกิดขึ้นเท่านั้น แต่ผู้ให้บริการไม่ต้องรับผิดชอบในความเสียหายที่เกิดขึ้นจากพฤติการณ์พิเศษ ทั้งนี้ ผู้ใช้บริการตกลงว่า ไม่ว่าในกรณีใด ๆ ผู้ให้บริการไม่ต้องรับผิดชอบในความเสียหายที่เกิดขึ้นจากสาเหตุต่าง ๆ ดังต่อไปนี้ 
      (1) มีการใช้รหัสเข้าใช้บริการควบคู่กับการยืนยันการเปิดการใช้บริการของผู้ใช้บริการ หรือวิธีการอื่นใด ตามที่ผู้ให้บริการกำหนด ไม่ว่าจะเป็นการกระทำของผู้ใดก็ตาม 
      (2) เหตุสุดวิสัยต่าง ๆ หรือเหตุการณ์ที่ผู้ให้บริการไม่สามารถควบคุมได้ ซึ่งรวมถึงการที่อุปกรณ์ ระบบสื่อสาร หรือการส่งสัญญาณเชื่อมต่อไม่ทำงาน หรือถูกรบกวนจากไวรัสคอมพิวเตอร์ หรือจากการกระทำที่ไม่ชอบด้วยกฎหมาย หรือในกรณีที่ผู้ให้บริการปิดการให้บริการ เพื่อปรับปรุงหรือบำรุงรักษาระบบ อันเป็นเหตุให้ผู้ใช้บริการไม่สามารถใช้บริการได้ 
      (3) ความล่าช้า ความผิดพลาด หรือความบกพร่องของระบบคอมพิวเตอร์ หรืออุปกรณ์ต่าง ๆ ของผู้ใช้บริการ ผู้ให้บริการ หรือผู้ให้บริการระบบเครือข่ายโทรคมาคมหรือเครือข่ายการสื่อสารอื่น เว้นแต่ในกรณีที่ความล่าช้า ความผิดพลาด หรือความบกพร่องดังกล่าว เกิดจากความจงใจหรือประมาทเลินเล่ออย่างร้ายแรงของผู้ให้บริการ 
      (4) ความล่าช้าในขั้นตอนการดำเนินการของบริการ แอพลิเคชัน มาย บี พลัส
      (5) การที่ผู้ใช้บริการไม่ปฏิบัติตามข้อกำหนดและเงื่อนไขของบริการ   `,
  },
  {
    title: "",
    header: "9. การชดใช้ค่าเสียหาย",
    dtailList: `ผู้ใช้บริการตกลงว่าจะปกป้องและชดใช้ค่าเสียหายให้แก่ผู้ให้บริการ และบริษัทในเครือ พนักงาน คู่สัญญาทางธุรกิจ และลูกจ้าง จากการกล่าวอ้าง เรียกร้อง การกระทำ กระบวนการทางกฎหมาย ความรับผิด บทลงโทษ และค่าใช้จ่ายต่าง ๆ (รวมถึงค่าใช้จ่ายทางด้านกฎหมาย)อันเนื่องจาก 
      (ก) การที่ผู้ใช้บริการเข้าถึงบริการนี้
      (ข) การที่ผู้ใช้บริการละเมิดสิทธิของบุคคลหรือนิติบุคคลอื่น ไม่ว่าจะเกิดขึ้นด้วยความจงใจหรือประมาทเลินเล่อของผู้ใช้บริการหรือ 
      (ค) จากการทำผิดข้อกำหนดและเงื่อนไขนี้ หรือเหตุอื่นใด  `,
  },
  {
    title: "",
    header: "10. ข้อมูลการติดต่อ และการส่งคำบอกกล่าว",
    dtailList: `10.1 ผู้ใช้บริการตกลงให้ผู้ให้บริการติดต่อสอบถาม เก็บ รวบรวม หรือ ใช้ข้อมูลบางประการหรือทั้งหมดเกี่ยวกับผู้ใช้บริการ และที่เกี่ยวกับการให้บริการได้ ตามความจำเป็นและเหมาะสม  
      10.2 หนังสือ จดหมาย คำบอกกล่าวใด ๆ ของผู้ให้บริการที่จัดส่งให้แก่ผู้ใช้บริการทางไปรษณีย์ หรือไปรษณีย์อิเล็กทรอนิกส์ (E-mail) ตามที่อยู่ซึ่งผู้ใช้บริการได้แจ้งให้ผู้ให้บริการทราบ ให้ถือว่า เป็นการจัดส่งให้แก่ผู้ขอใช้บริการโดยชอบแล้ว และในกรณีที่ผู้ใช้บริการเปลี่ยนแปลงที่อยู่ดังกล่าว ผู้ใช้บริการจะแจ้งให้ผู้ให้บริการทราบเป็นลายลักษณ์อักษร  
      10.3 ผู้ใช้บริการสามารถติดต่อสอบถาม หรือแจ้งปัญหาเกี่ยวกับการใช้บริการนี้ โดยติดต่อได้ที่ 
      บริการ แอปพลิเคชัน มาย บี พลัส
      บริษัท กรุงเทพดุสิตเวชการ
      เลขที่ 2 ซอยศูนย์วิจัย 7 ถนนเพชรบุรีตัดใหม่ แขวงบางกะปิ เขตห้วยขวาง กรุงเทพมหานคร10310 
      เบอร์โทรศัพท์ 02-310-3000  เบอร์โทรสาร 02-318-1546 
      อีเมล  info@bangkokhospital.co.th `,
  },
  {
    title: "",
    header: "12. ทรัพย์สินทางปัญญา",
    dtailList: `12.1 การใช้บริการของผู้ใช้บริการ ไม่เป็นการให้ความเป็นเจ้าของในทรัพย์สินทางปัญญาใด ที่เกี่ยวกับบริการหรือเนื้อหาที่ผู้ใช้บริการเข้าถึง 
      12.2 ผู้ให้บริการและ/หรือคู่สัญญาทางธุรกิจ เป็นเจ้าของในสิทธิ และประโยชน์ใด ๆ ที่เกี่ยวข้องกับลิขสิทธิ์ เครื่องหมายการค้า สิทธิบัตร และทรัพย์สินทางปัญญาอื่น ๆ หรือ สิทธิใด ๆ ของบริการนี้ รวมถึงงานผลิตภัณฑ์ หรือการปรับปรุงแก้ไข การออกแบบ หรืองานอื่นใดที่เกิดขึ้น หรือสร้างขึ้นโดยผู้ให้บริการ `,
  },
  {
    title: "",
    header: "13. ความสมบูรณ์ของข้อกำหนดและเงื่อนไข",
    dtailList: `ในกรณีที่ปรากฏว่ามีข้อกำหนดหรือเงื่อนไขใดในเอกสารนี้ไม่สมบูรณ์ ตกเป็นโมฆะ หรือใช้บังคับไม่ได้ ไม่ว่าด้วยประการใด ๆ ให้ถือว่าข้อกำหนดหรือเงื่อนไขที่ไม่สมบูรณ์ ตกเป็นโมฆะ หรือใช้บังคับไม่ได้ดังกล่าวนั้น ไม่มีผลกระทบต่อความสมบูรณ์หรือการบังคับใช้ข้อกำหนดและเงื่อนไขอื่น ๆ ในเอกสารนี้ `,
  },
  {
    title: "",
    header: "14. กฎหมายที่ใช้บังคับ",
    dtailList: `หากมีข้อพิพาทใดเกิดขึ้นจากการให้บริการของผู้ให้บริการ อันเนื่องมาจากบริการนี้ ผู้ใช้บริการและผู้ให้บริการตกลงใช้กฎหมายไทยและให้เฉพาะศาลไทยเป็นศาลที่มีเขตอำนาจในการพิจารณาข้อพิพาทที่เกิดขึ้นเกี่ยวกับการใช้บริการตามข้อกำหนดและเงื่อนไขนี้`,
  },
];

export const privacyPolicy = [
  {
    title:
      "นโยบายความเป็นส่วนตัวของผู้รับบริการตรวจและรักษาโรค (Patient Privacy Notice) บริษัท กรุงเทพดุสิตเวชการ จำกัด (มหาชน)",
    header: "",
    dtailList: `บริษัท กรุงเทพดุสิตเวชการ จำกัด (มหาชน) (“บริษัทฯ”) มุ่งมั่นที่จะคุ้มครองข้อมูลส่วนบุคคลของท่านในฐานะที่ท่านเป็นผู้เข้ารับบริการตรวจ รักษาโรค และบริการทางการแพทย์ รวมถึงบริการต่างๆ จากบริษัทฯ ข้อมูลส่วนบุคคลของท่านจะได้รับการคุ้มครองตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 บริษัทฯ ในฐานะผู้ควบคุมข้อมูลส่วนบุคคลมีหน้าที่ตามกฎหมายในการแจ้งเอกสารฉบับนี้ให้ท่านทราบถึงเหตุผลและวิธีการที่บริษัทฯ เก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของท่าน รวมถึงแจ้งให้ท่านทราบสิทธิของท่านในฐานะเจ้าของข้อมูลส่วนบุคคล`,
  },
  {
    title: "",
    header: "วัตถุประสงค์",
    dtailList: `บริษัทฯ ประมวลผลข้อมูลส่วนบุคคลของท่านภายใต้ขอบเขตที่กำหนดไว้โดยพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 และประมวลผลข้อมูลเพียงเท่าที่จำเป็นสำหรับการดำเนินการดังกล่าว โดยบริษัทฯ ได้สรุปการใช้ข้อมูลส่วนบุคคลของท่าน พร้อมทั้งอธิบายฐานการประมวลผลข้อมูลส่วนบุคคลที่ชอบด้วยกฎหมาย (Lawful Basis of Processing) ดังนี้`,
  },
  {
    key: "table-01",
    title: "",
    header: "",
    dtailList: ``,
    table: {
      title: [
        "",
        "วัตถุประสงค์",
        "ประเภทข้อมูล",
        "ฐานการประมวลผลที่ชอบด้วยกฎหมาย",
      ],
      detail: [
        [
          "1.",
          `เพื่อวัตถุประสงค์ในการตรวจรักษาโรคและให้บริการทางการแพทย์
        1.1. การให้บริการทางการแพทย์ภายในสถานพยาบาลของบริษัทฯ
        คณะแพทย์ พยาบาล และ/หรือ บุคลากรอื่นๆ ในทีมสุขภาพของบริษัทฯ จะทำการบันทึกข้อมูลส่วนบุคคลของท่าน นำข้อมูลส่วนบุคคลของท่านเพื่อปรึกษาแพทย์หรือบุคลากรทางการแพทย์ รวมถึงถ่ายภาพนิ่งและภาพเคลื่อนไหว เพื่อติดตามการรักษา และ/หรือ กระทำการใดๆ ตามหลักวิชาชีพที่เกี่ยวข้องตลอดระยะเวลาที่ท่านเข้ารับบริการ โดยบริษัทฯ จะอธิบายข้อมูลรายละเอียดให้ท่านได้เข้าใจก่อนที่จะดำเนินการ อีกทั้งเปิดโอกาสให้ท่านซักถามจนเป็นที่พอใจ
        1.2. การให้บริการทางการแพทย์ในกรณีจำเป็นต้องเชื่อมโยงข้อมูลระหว่างสถานพยาบาลในเครือข่าย
        เพื่อประโยชน์ในการให้บริการทางการแพทย์แก่ท่าน คณะแพทย์ พยาบาล และ/หรือ บุคลากรอื่นๆเกี่ยวข้องของบริษัทฯ อาจเปิดเผยข้อมูลส่วนบุคคลของท่านให้สถานพยาบาลในเครือข่ายในกรณีที่จำเป็นต้องใช้ข้อมูลระหว่างสถานพยาบาลในเครือข่ายเพื่อการให้บริการบางประเภท ทั้งนี้ บริษัทฯ ได้จัดให้มีมาตรการคุ้มครองข้อมูลส่วนบุคคลโดยมีข้อตกลงร่วมกันระหว่างสถานพยาบาลในเครือข่ายเพื่อป้องกันไม่ให้เกิดการประมวลผลข้อมูลส่วนบุคคลของท่านในทางที่มิชอบด้วยกฎหมาย หรือโดยปราศจากอำนาจ
        1.3 เพื่อรับ–ส่งต่อผู้ป่วยระหว่างสถานพยาบาล (Refer)
        ในกรณีที่บริษัทฯ มีคำร้องขอหรือได้รับการร้องขอให้เคลื่อนย้ายผู้ป่วยจากสถานพยาบาลหนึ่ง เพื่อไปรับการตรวจรักษาต่อที่สถานพยาบาลอื่น หรือมีคำร้องขอหรือได้รับคำร้องขอให้รับผู้ป่วยจากสถานพยาบาลหนึ่งเพื่อเข้ารับการรักษาในสถานพยาบาลของบริษัทฯ ตามกระบวนการรับ-ส่งต่อผู้ป่วยระหว่างสถานพยาบาล (Refer) บริษัทฯ จะต้องดำเนินตามกระบวนการรับ-ส่งต่อผู้ป่วยที่กำหนดไว้ตามมาตรฐานของบริษัทฯ และจะใช้ข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์ในการรับ-ส่งต่อผู้ป่วยเท่านั้น ไม่นำไปใช้ในวัตถุประสงค์อื่น`,
          `– ข้อมูลระบุตัวตน
        – ข้อมูลสำหรับการติดต่อ
        – ข้อมูลด้านสุขภาพ
        – ข้อมูลการเงิน`,
          `สำหรับข้อมูลส่วนบุคคลที่อ่อนไหว: เพื่อป้องกันหรือระงับอันตรายต่อชีวิต ร่างกาย หรือสุขภาพในกรณีที่เจ้าของข้อมูลส่วนบุคคลไม่สามารถให้ความยินยอมได้ เช่น การเข้ารับบริการในกรณีฉุกเฉิน (Emergency Care) หรือเพื่อรับ – ส่งต่อผู้ป่วยระหว่างโรงพยาบาล (Refer) (ม.26 (1))`,
        ],
        [
          "2.",
          `เพื่อวัตถุประสงค์ในการศึกษาวิเคราะห์เพื่อพัฒนาคุณภาพของการรักษาพยาบาลโดยไม่บ่งชี้ตัวตนของเจ้าของข้อมูลส่วนบุคคล
        บริษัทฯ อาจนำข้อมูลส่วนบุคคลของท่านไปใช้เพื่อการศึกษาวิเคราะห์เพื่อการพัฒนาคุณภาพของการรักษาพยาบาล โดยจะทำเป็นรูปแบบรายงานผลโดยภาพรวมที่ไม่มีการบ่งชี้ตัวตนของเจ้าของข้อมูล และบริษัทฯ จะรักษาความลับของข้อมูลดังกล่าวของท่านอย่างเคร่งครัด`,
          `ข้อมูลสถิติ`,
          ``,
        ],
        [
          "3.",
          `การเปิดเผยข้อมูลให้บริษัทประกันภัยที่ท่านหรือบริษัทฯ เป็นคู่สัญญาเพื่อวัตถุประสงค์ในการใช้สิทธิเรียกค่าสินไหมทดแทนจากบริษัทประกันภัยหรือใช้สิทธิเบิกค่ารักษาพยาบาล
        บริษัทจำเป็นต้องเปิดเผยข้อมูลส่วนบุคคลของท่านให้บริษัทประกันภัยเพื่อการปฏิบัติตามสัญญาที่ท่านหรือบริษัทฯ ได้ทำไว้กับบริษัทประกันภัย เพื่อประโยชน์ในการเบิกจ่ายค่าสินไหมทดแทนหรือใช้สิทธิเบิกค่ารักษาพยาบาล ทั้งนี้ บริษัทฯ จะไม่เปิดเผยข้อมูลส่วนบุคคลของท่านให้กับบุคคลอื่นใดที่ไม่เกี่ยวข้อง`,
          `– ข้อมูลระบุตัวตน
        – ข้อมูลสำหรับการติดต่อ
        – ข้อมูลด้านสุขภาพ`,
          `เมื่อได้รับความยินยอมโดยชัดแจ้งจากท่านในการเปิดเผยข้อมูลส่วนบุคคลที่เป็นข้อมูลด้านสุขภาพให้บริษัทประกันภัยเพื่อประโยชน์ในการใช้สิทธิเรียกค่าสินไหมทดแทนจากบริษัทประกันภัยหรือใช้สิทธิเบิกค่ารักษาพยาบาล (ม.26)`,
        ],
        [
          "4.",
          `การเปิดเผยข้อมูลให้ผู้ที่ส่งท่านมาตรวจหรือเป็นผู้ชำระเงินเมื่อท่านได้ยินยอมให้เปิดเผยข้อมูลส่วนบุคคล
        ในกรณีที่หน่วยงานไม่ว่าภาครัฐ เอกชน หรือรัฐวิสาหกิจเป็นผู้ส่งท่านมาตรวจรักษากับบริษัทฯ หรือเป็นผู้ชำระค่าบริการตรวจรักษาให้แก่ท่าน บริษัทฯ จะเปิดเผยข้อมูลการตรวจรักษาซึ่งเป็นข้อมูลส่วนบุคคลที่อ่อนไหวให้กับบุคคลดังกล่าวเฉพาะกรณีที่ท่านได้ให้ความยินยอมในการเปิดเผยข้อมูลส่วนบุคคลของท่านให้กับบุคคลดังกล่าวเท่านั้น ถ้าท่านไม่ได้ให้ความยินยอมดังกล่าว บริษัทฯ จะส่งผลตรวจรักษาให้ท่านโดยตรง`,
          `– ข้อมูลระบุตัวตน
        – ข้อมูลสำหรับการติดต่อ
        – ข้อมูลด้านสุขภาพ`,
          `เมื่อได้รับความยินยอมโดยชัดแจ้งจากท่านในการเปิดเผยข้อมูลส่วนบุคคล (ม.26)`,
        ],
        [
          "5.",
          `เพื่อวัตถุประสงค์ในการเชื่อมโยงฐานข้อมูลอิเล็กทรอนิกส์ด้านเวชระเบียนระหว่างสถานพยาบาลผ่านโมบายแอพพลิเคชั่น
        เมื่อท่านให้ความยินยอม บริษัทฯ จะนำข้อมูลส่วนบุคคลของท่านเข้าสู่ระบบคอมพิวเตอร์ในรูปแบบของโมบายแอพพลิเคชั่นเพื่ออำนวยความสะดวกให้ท่านในการรับคำปรึกษาผ่านแอพพลิเคชั่น และเพื่อให้ท่านสามารถบริหารจัดการข้อมูลผ่านแอพพลิเคชั่นได้ และเพื่อให้เกิดประโยชน์สูงสุด ระบบจะทำการเชื่อมโยงฐานข้อมูลอิเล็กทรอนิกส์ด้านเวชระเบียนระหว่างสถานพยาบาลในเครือข่ายเพื่อให้ท่านสามารถเรียกดูข้อมูลส่วนบุคคลของท่านที่มีอยู่กับสถานพยาบาลในเครือข่ายผ่านอุปกรณ์อิเล็กทรอนิกส์ต่างๆ ได้ โดยบริษัทฯ มีความตกลงร่วมกับสถานพยาบาลในเครือข่ายเพื่อคุ้มครองข้อมูลส่วนบุคคลของท่านให้เป็นไปตามที่ พรบ.คุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 กำหนด`,
          `– ข้อมูลระบุตัวตน
        – ข้อมูลสำหรับการติดต่อ
        – ข้อมูลด้านสุขภาพ`,
          `เมื่อได้รับความยินยอมโดยชัดแจ้งจากท่านในการเปิดเผยข้อมูลด้านสุขภาพระหว่างสถานพยาบาล (ม.26)`,
        ],
        [
          "6.",
          `เพื่อวัตถุประสงค์ทางการตลาดของบริษัทฯ
        บริษัทฯ อาจทำการเก็บรวบรวม ใช้ และประมวลผลข้อมูลส่วนบุคคลเพื่อวิเคราะห์สภาวะสุขภาพของท่าน และติดต่อเพื่อสื่อสาร ส่งข้อมูลข่าวสารด้านการแพทย์ และนำเสนอโปรโมชั่น สินค้าและบริการ แก่ท่านตามที่ท่านได้ให้ความยินยอม`,
          `– ข้อมูลระบุตัวตน
        – ข้อมูลสำหรับการติดต่อ
        – ข้อมูลการสมัครข่าวสารและการเข้าร่วมกิจกรรมทางการตลาด`,
          `บริษัทฯ จะดำเนินการในเรื่องนี้ได้หลังจากได้รับความยินยอมจากท่านในการให้บริษัทฯ นำข้อมูลด้านสุขภาพไปใช้เพื่อวัตถุประสงค์ทางการตลาด (ม.26)`,
        ],
      ],
    },
  },
  {
    title: "",
    header: "",
    dtailList: `นอกจากวัตถุประสงค์ที่ระบุข้างต้นแล้ว บริษัทฯ จะไม่นำข้อมูลส่วนบุคคลของท่านไปใช้เพื่อวัตถุประสงค์อื่น ยกเว้นในกรณีที่พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 อนุญาต เช่น
    •	เมื่อได้รับความยินยอมจากท่าน (ม.24) หรือเมื่อได้รับความยินยอมโดยชัดแจ้งจากท่านในกรณีการใช้ข้อมูลส่วนบุคคลที่อ่อนไหว (ม.26)
    •	เพื่อการศึกษาวิจัยหรือสถิติซึ่งได้จัดให้มีมาตรการปกป้องที่เหมาะสมเพื่อคุ้มครองข้อมูลส่วนบุคคลสิทธิและเสรีภาพของเจ้าของข้อมูลส่วนบุคคล (ม.24 (1))
    •	เพื่อป้องกันระงับอันตรายต่อชีวิต ร่างกาย หรือสุขภาพ (ม.24 (2))
    •	เพื่อการปฏิบัติตามสัญญาระหว่างบริษัทฯ กับท่าน (ม.24 (3))
    •	เพื่อปฏิบัติหน้าที่ในการดำเนินภารกิจเพื่อประโยชน์สาธารณะของบริษัทฯ (ม.24 (4))
    •	เพื่อประโยชน์โดยชอบด้วยกฎหมายของบริษัท (Legitimate Interest) หรือของบุคคลหรือนิติบุคคลอื่น เว้นแต่ประโยชน์ดังกล่าวมีความสำคัญน้อยกว่าสิทธิขั้นพื้นฐานของเจ้าของข้อมูลส่วนบุคคล (ม.24 (5))
    •	เพื่อการปฏิบัติตามกฎหมายของบริษัทฯ (ม.24 (6))
    •	เพื่อป้องกันระงับอันตรายต่อชีวิต ร่างกาย หรือสุขภาพในกรณีที่การใช้ข้อมูลส่วนบุคคลที่อ่อนไหวที่เจ้าของข้อมูลส่วนบุคคลไม่สามารถให้ความยินยอมได้ ไม่ว่ากรณีใดก็ตาม (ม.26 (1))
    •	เพื่อการก่อตั้งสิทธิเรียกร้องตามกฎหมาย (ม.26 (4))
    •	เพื่อประโยชน์ด้านสาธารณสุข หรือการคุ้มครองทางสังคมอื่นใดโดยบริษัทฯ จัดให้มีมาตรการที่เหมาะสมเพื่อคุ้มครองสิทธิขั้นพื้นฐานและประโยชน์ของเจ้าของข้อมูลส่วนบุคคล (ม.26 (5) (ข))
    •	เพื่อความจำเป็นในการปฏิบัติตามกฎหมายด้านการคุ้มครองแรงงาน การให้สวัสดิการรักษาพยาบาล การประกันสังคม (ม.26 (5) (ค))`,
  },
  {
    title: "",
    header: "นิยาม",
    dtailList: `
    “ข้อมูลส่วนบุคคล” หมายถึง ข้อมูลเกี่ยวกับบุคคลซึ่งทำให้สามารถระบุตัวบุคคลนั้นได้ไม่ว่าทางตรงหรือทางอ้อม แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรมโดยเฉพาะ

    “ข้อมูลส่วนบุคคลที่อ่อนไหว” หมายถึง ข้อมูลส่วนบุคคลที่เกี่ยวกับเชื้อชาติ เผ่าพันธุ์ ความคิดเห็นทางการเมือง ความเชื่อในลัทธิ ศาสนาหรือปรัชญา พฤติกรรมทางเพศ ประวัติอาชญากรรม ข้อมูลสุขภาพ ความพิการ ข้อมูลสหภาพแรงงาน ข้อมูลพันธุกรรม ข้อมูลชีวภาพ (เช่น ข้อมูลภาพจำลองใบหน้า ข้อมูลจำลองม่านตา ข้อมูลจำลองลายนิ้วมือ) หรือข้อมูลอื่นใดที่กระทบต่อเจ้าของข้อมูลส่วนบุคคลในทำนองเดียวกันตามที่คณะกรรมการคุ้มครองข้อมูลส่วนบุคคลประกาศกำหนด
    
    “ข้อมูลการรักษาพยาบาล” หมายถึง ข้อมูลดังต่อไปนี้
    
    • วันเดือนปีที่เข้ารับการรักษา
    • ประวัติแพ้ยาและประวัติผลข้างเคียงจากยา
    • ประวัติแพ้อาหาร
    • ชื่อโรคที่ได้รับการวินิจฉัย ชื่อหัตถการ และชื่อการผ่าตัด
    • ผลเลือด ผลตรวจทางห้องปฏิบัติการ ผลตรวจชิ้นเนื้อทางพยาธิวิทยา ภาพถ่ายทางรังสีวิทยา และรายงานผลการ ทางรังสีวิทยา
    • รายการยาที่แพทย์ได้สั่ง
    • ข้อมูลอื่น เช่น อาการ คำแนะนำของแพทย์ และรายละเอียดการวินิจฉัยโรค เป็นต้น
    • “ประมวลผล” หมายถึง เก็บรวบรวม ใช้ หรือเปิดเผย
    
    “ผู้ควบคุมข้อมูลส่วนบุคคล” หมายถึง บุคคลหรือนิติบุคคลที่มีอํานาจในการตัดสินใจเกี่ยวกับการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล
    
    “ผู้ประมวลผลข้อมูลส่วนบุคคล” หมายถึง บุคคลหรือนิติบุคคลซึ่งดำเนินการเกี่ยวกับการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลตามคำสั่งหรือในนามของผู้ควบคุมข้อมูลส่วนบุคคล ทั้งนี้ บุคคลหรือนิติบุคคลซึ่งดำเนินการดังกล่าวไม่เป็นผู้ควบคุมข้อมูลส่วนบุคคล
    
    “กลุ่มบริษัทกรุงเทพดุสิตเวชการ” หมายถึง บริษัทที่อยู่ในเครือข่ายของบริษัท กรุงเทพดุสิตเวชการ จำกัด (มหาชน) ทั้งที่มีอยู่ในปัจจุบันและที่จะมีขึ้นในอนาคตไม่ว่าจะจดทะเบียนในประเทศไทยหรือในต่างประเทศ ซึ่งรวมถึงบริษัท กรุงเทพดุสิตเวชการ จำกัด (มหาชน) ด้วย
    
    “สถานพยาบาลในเครือข่าย” หมายถึง สถานพยาบาลในกลุ่มหรือในเครือข่ายของบริษัทกรุงเทพดุสิตเวชการ จำกัด (มหาชน) ทั้งที่ประกอบกิจการในประเทศไทยและในต่างประเทศ`,
  },
  {
    title: "",
    header: "ข้อมูลส่วนบุคคลที่บริษัทฯ เก็บรวบรวมจากท่าน",
    dtailList: `ข้อมูลส่วนบุคคลของท่านที่บริษัทฯ เก็บรวบรวม สามารถจำแนกเป็นประเภทดังต่อไปนี้`,
  },
  {
    key: "table-02",
    title: "",
    header: "",
    dtailList: ``,
    table: {
      title: ["ประเภทข้อมูลส่วนบุคคล", "รายละเอียด"],
      detail: [
        [
          "1. ข้อมูลระบุตัวตน (Personal data)",
          "เช่น ชื่อ นามสกุล เลขที่บัตรประชาชน ID รูปถ่ายใบหน้า เพศ วันเดือนปีเกิด หนังสือเดินทาง หรือหมายเลขที่ระบุตัวตนอื่น ๆ",
        ],
        [
          "2. ข้อมูลสำหรับการติดต่อ (Contact data)",
          "เช่น ที่อยู่ หมายเลขโทรศัพท์ อีเมล",
        ],
        [
          "3. ข้อมูลการเงิน (Financial data)",
          "เช่น ข้อมูลการเรียกเก็บเงิน ข้อมูลบัตรเครดิตหรือเดบิต ข้อมูลใบเสร็จ ข้อมูลใบราคา",
        ],
        [
          "4. ข้อมูลการสมัครข่าวสารและการเข้าร่วมกิจกรรมทางการตลาด (Marketing Data)",
          "เช่น ข้อมูลที่ใช้ในการลงทะเบียนเพื่อรับข่าวสารและเข้าร่วมกิจกรรมทางการตลาด",
        ],
        [
          "5. ข้อมูลจากการเข้าใช้เว็บไซต์ (Technical data)",
          "เช่น หมายเลข IP Address ของคอมพิวเตอร์ ชนิดของบราวเซอร์ ข้อมูล Cookies การตั้งค่าเรื่องเขตเวลา (time zone) ระบบปฏิบัติการ แพลตฟอร์มและเทคโนโลยีของอุปกรณ์ที่ใช้เข้าเว็บไซต์ และ Online Appointment System",
        ],
        [
          "6. ข้อมูลด้านสุขภาพ (Health data)",
          "เช่น ข้อมูลการรักษาพยาบาล รายงานที่เกี่ยวกับสุขภาพกายและสุขภาพจิต การดูแลสุขภาพของผู้รับบริการ ผลการทดสอบจากห้องทดลอง การวินิจฉัย ชื่อโรคที่ได้รับการวินิจฉัย ข้อมูลที่เกี่ยวข้องกับการใช้ยาและแพ้ยา ประวัติแพ้อาหาร ผลเลือด ผลตรวจทางห้องปฏิบัติการ ผลตรวจชิ้นเนื้อทางพยาธิวิทยา ภาพถ่ายทางรังสีวิทยา และรายงานผลการตรวจทางรังสีวิทยารายการยาที่แพทย์ได้สั่ง ข้อมูลที่จำเป็นต่อการให้บริการทางการแพทย์ ข้อมูล Feedback และผลการรักษา",
        ],
      ],
    },
  },
  {
    title: "",
    header: "แหล่งที่มาของข้อมูลส่วนบุคคล",
    dtailList: `บริษัทฯ เก็บรวบรวมข้อมูลส่วนบุคคลของท่านจากแหล่งที่มาดังต่อไปนี้
  1. ข้อมูลส่วนบุคคลที่ได้โดยตรงจากท่าน ได้แก่
      • กรณีที่ท่านเป็นผู้เข้ารับบริการตรวจและรักษาโรค: บริษัทฯ ได้ข้อมูลส่วนบุคคลของท่านจากการที่ท่านติดต่อสอบถามกับบริษัทฯ เรื่องการบริการ หรือท่านได้ลงทะเบียนเข้ารับบริการทางการแพทย์ และบริการต่างๆ จากบริษัทฯ ด้วยตนเองที่บริษัทฯ รวมทั้งการลงทะเบียนผ่านสื่ออิเล็กทรอนิกส์
  2. ข้อมูลส่วนบุคคลที่ได้รับโดยทางอ้อม ได้แก่
      • บุคคลที่มีความใกล้ชิดกับท่าน เช่น ญาติ คู่สมรส เป็นต้น
      • บุคคลที่ท่านมอบอำนาจให้ดำเนินการแทนตัวท่านในการติดต่อกับโรงพยาบาล
      • สถานพยาบาลในเครือข่ายในกรณีที่ท่านได้ให้ความยินยอมกับสถานพยาบาลในเครือข่ายไว้ว่าให้เปิดเผยข้อมูลส่วนบุคคลของท่านได้
      • บุคคล นิติบุคคล หรือหน่วยงานไม่ว่าภาครัฐ เอกชน หรือรัฐวิสาหกิจที่เป็นผู้ส่งท่านมาตรวจรักษาหรือใช้บริการกับบริษัทฯ หรือเป็นผู้ชำระค่าบริการให้กับท่าน`,
  },
  {
    title: "",
    header: "การเปิดเผยหรือแบ่งปันข้อมูลส่วนบุคคล",
    dtailList: `บริษัทฯ จะไม่เปิดเผยข้อมูลส่วนบุคคลของท่านให้บุคคลภายนอก ยกเว้นเป็นกรณีที่กฎหมายอนุญาตเพื่อความจำเป็นในการปฏิบัติงาน ซึ่งทำให้บริษัทฯ อาจเปิดเผยข้อมูลส่วนบุคคลได้ในกรณีต่อไปนี้
  1. เปิดเผยข้อมูลส่วนบุคคลให้หน่วยงานราชการ หน่วยงานผู้มีอำนาจหรือบุคคลใดๆ เมื่อมีกฎหมายกำหนดหรือให้อำนาจ รวมถึงการปฏิบัติตามคำสั่งศาล
  2. การเปิดเผยข้อมูลส่วนบุคคลให้กับบุคคลหรือนิติบุคคลที่บริษัทฯ จำเป็นต้องปฏิบัติตามสัญญาหรือเพื่อผลประโยชน์ของท่านในฐานะเจ้าของข้อมูลส่วนบุคคล โดยบริษัทฯ กำหนดให้บุคคลหรือนิติบุคคลเหล่านี้ต้องรักษาความลับและคุ้มครองข้อมูลส่วนบุคคลของท่านตามมาตรฐานที่พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 กำหนด ซึ่งรวมถึงแต่ไม่จำกัดเพียงบุคคลหรือนิติบุคคลในข้อนี้ได้แก่
      • สถานพยาบาลในเครือข่าย และกลุ่มบริษัทกรุงเทพดุสิตเวชการ...
      • บริษัทประกันภัย หรือผู้ให้บริการบริหารจัดการสินไหม...
      • สถานพยาบาลที่รับการส่งต่อผู้ป่วย
      • ผู้ส่งท่านมาตรวจรักษา...
      • ผู้ประมวลผลข้อมูลส่วนบุคคล เช่น ผู้รับจ้างตรวจห้องแล็บ โทรคมนาคม เทคโนโลยี ฯลฯ
  3. บริษัทฯ อาจเก็บข้อมูลไว้ในระบบคลาวด์ (Cloud Computing)... ทั้งในประเทศและต่างประเทศ โดยเลือกผู้ให้บริการที่มีมาตรฐานความปลอดภัย`,
  },
  {
    title: "",
    header: "ระยะเวลาในการเก็บรักษาข้อมูลส่วนบุคคล",
    dtailList: `1. บริษัทฯ จะเก็บเวชระเบียนเป็นเวลาอย่างน้อย 5 ปี และอาจเก็บต่อจนไม่ได้รับการติดต่อเกิน 10 ปี เมื่อครบกำหนดแล้วจะทำลายทั้งฉบับจริง สำเนา และเวชระเบียนอิเล็กทรอนิกส์
  2. หากจำเป็นต้องปฏิบัติตามกฎหมาย คำสั่งศาล หรือเพื่อก่อตั้งสิทธิเรียกร้อง บริษัทฯ จะเก็บไว้ตามอายุความตามที่กฎหมายหรือข้อบังคับกำหนด`,
  },
  {
    title: "",
    header: "มาตรการในการเก็บรักษาและประมวลผลข้อมูลส่วนบุคคล",
    dtailList: `1. ใช้มาตรการความปลอดภัยตามที่กฎหมายกำหนด เช่น SSL, Firewall, Password, การเข้ารหัส
  2. จำกัดสิทธิ์เข้าถึงข้อมูลให้เฉพาะบุคคลที่จำเป็น เช่น พนักงาน ตัวแทน คู่ค้า
  3. มีระบบป้องกันไม่ให้เข้าระบบคอมพิวเตอร์โดยไม่ได้รับอนุญาต
  4. ตรวจสอบและจัดการทำลายข้อมูลที่ไม่จำเป็น
  5. สำหรับข้อมูลอ่อนไหว มีมาตรการเข้มงวด เช่น สำรองข้อมูล แผนฉุกเฉิน ประเมินความเสี่ยง`,
  },
  {
    title: "",
    header: "การโอนข้อมูลส่วนบุคคลไปยังต่างประเทศ",
    dtailList: `1. บริษัทฯ อาจโอนข้อมูลไปยังต่างประเทศได้โดยแจ้งวัตถุประสงค์และได้รับความยินยอมจากท่าน พร้อมแจ้งระดับความคุ้มครองของประเทศปลายทาง
  2. บริษัทฯ อาจโอนได้โดยไม่ต้องขอความยินยอมหากเป็นการปฏิบัติตามสัญญา ป้องกันอันตรายต่อชีวิต หรือกรณีตามกฎหมาย`,
  },
  {
    title: "",
    header: "นโยบายเกี่ยวกับคุกกี้ (Cookie Policy)",
    dtailList: `บริษัทฯ ใช้คุกกี้เพื่อพัฒนาประสบการณ์การใช้งานเว็บไซต์ โดยจัดเก็บข้อมูลในเครื่องของท่านผ่านเว็บเบราว์เซอร์ อาจให้บุคคลที่สามเข้าถึงข้อมูลเพื่อวิเคราะห์ เชื่อมโยง และประมวลผลทางการตลาด ท่านสามารถตั้งค่าคุกกี้ได้ตามความต้องการเมื่อเข้าสู่เว็บไซต์`,
  },
  {
    title: "",
    header: "สิทธิของเจ้าของข้อมูลส่วนบุคคล",
    dtailList: `1. สิทธิในการเพิกถอนความยินยอม
  2. สิทธิในการเข้าถึงข้อมูล
  3. สิทธิในการแก้ไขข้อมูลให้ถูกต้อง
  4. สิทธิในการลบข้อมูล
  5. สิทธิในการระงับการใช้ข้อมูล
  6. สิทธิในการโอนย้ายข้อมูล
  7. สิทธิในการคัดค้านการประมวลผลข้อมูล
  
  ติดต่อใช้สิทธิได้ที่ นายแพทย์ วิสุทธิ์ ลัจฉเสวี DPO Group1
  โทร 02-310-3331
  อีเมล: dpogroup1@bdms.co.th หรือ dpogroup1@bangkokhospital.com`,
  },
  {
    title: "",
    header: "การเปลี่ยนแปลงนโยบายคุ้มครองข้อมูลส่วนบุคคล",
    dtailList: `บริษัทฯ อาจมีการเปลี่ยนแปลงนโยบายคุ้มครองข้อมูลส่วนบุคคลในอนาคต และจะแจ้งให้ท่านทราบทุกครั้งที่มีการเปลี่ยนแปลง`,
  },
  {
    title: "",
    header: "ช่องทางการติดต่อ",
    dtailList: `ติดต่อ: นายแพทย์ วิสุทธิ์ ลัจฉเสวี (DPO Group1)
  บริษัท กรุงเทพดุสิตเวชการ จำกัด (มหาชน)
  เลขที่ 2 ซอยศูนย์วิจัย 7 ถนนเพชรบุรีตัดใหม่ แขวงบางกะปิ เขตห้วยขวาง กรุงเทพฯ
  โทรศัพท์: 02-310-3331
  อีเมล: dpogroup1@bdms.co.th หรือ dpogroup1@bangkokhospital.com`,
  },
];

export const privacyPolicyEn = [
  {
    title:
      "Patient Privacy Notice Bangkok Dusit Medical Services Public Company Limited",
    header: "",
    dtailList: `Bangkok Dusit Medical Services Public Company Limited (“BDMS”) commits to protect your personal data as a patient who undergoes investigation, treatment and medical services including other services provided by BDMS. Your personal data is to be protected in compliance with the Personal Data Protection Act B.E. 2562. BDMS as a controller of such personal data is responsible by law for notifying you of this document for reasons and methodology BDMS collects, gathers, uses or discloses your personal data, including informing you your rights as an owner of such personal data.`,
  },
  {
    title: "",
    header: "Objectives",
    dtailList: `BDMS analyzes your personal data under a scope as defined by Personal Data Protection Act B.E. 2562 and analyzes the data only as necessary for aforementioned action. Then BDMS concludes the use of your personal data as well as explaining Lawful Basis of Processing for the data as below details.
  
  Apart from aforementioned purposes, BDMS will not use your personal data for other purposes unless the Personal Data Protection Act B.E. 2562 permits such as
  • When receipt of your consent (Section. 24) or when receipt of intended consent in case of using sensitive personal data (Section. 26)
  • For analysis study or statistic which establishes appropriate protection measures...
  • To prevent, suppress threatening to life, body or health...
  • To comply with a contract between BDMS and you...
  • To perform duties accordingly to BDMS’s mission for public interests...
  • Legitimate Interest of BDMS...
  • For legal compliance of BDMS...
  • To prevent, suppress threatening to life, body or health in special cases...
  • For establishment rights for legal claims...
  • For public health interests or other social protection...
  • For needs to comply with Labor protection law, provision of medical welfare, social security...`,
  },
  {
    key: "table-01",
    title: "",
    header: "",
    dtailList: ``,
    table: {
      title: ["", "Purpose", "Type of Data", "Lawful Basis of Processing"],
      detail: [
        [
          "1.",
          `For a purpose of investigation and providing medical services
        1.1. Providing medical services within BDMS health providers
        BDMS’s teams of physicians, nurses and/or other staffs in health teams will record your personal data and take such the information for consultation with physicians or medical staffs including taking imaging and video for further follow up and/or any actions according to relevant professional principles throughout the period you are receiving the services as BDMS explains detailed information for your understanding prior to starting any services also opens chances for your to ask questions until your satisfaction met.
        1.2. Providing medical services if necessary to link data among network health providers   
        For benefits in providing you medical services, BDMS’s team of physicians, nurses and/or other relevant staffs may disclose your personal data to network health providers if necessary to use the data between the network health providers to provide some types of medical services. BDMS establishes measures to protect personal data by agreements among network health providers to prevent unlawful processing of your personal data or without authority.
        1.3 For Refer between health providers
        In case, BDMS puts or receives a request for refer of patient from one provider to another for continuation of cares or from one provider to BDMS’s provider according to refer as set by BDMS. BDMS conducts refer according to BDMS’s defined standards and will use your personal data for the purpose of refer only not for other purposes.`,
          `– Identified data
      – Contact data
      – Health data
      – Financial data`,
          `For sensitive personal data: to protect or suppress threatening to life, body or health, in case the owner of personal data cannot give self-consent such as undergoing Emergency care or refer between health providers (Section.26 (1))`,
        ],
        [
          "2.",
          `For purpose of analysis study to develop quality of treatments by unidentified personal data
      BDMS may use your personal data for analysis study to develop quality of treatments by an overall report with unidentified owners of personal data and the company strictly maintains confidentiality of such data.`,
          `Statistical data`,
          ``,
        ],
        [
          "3.",
          `Disclose of the data to your insurance companies or contractors for purposes of rights to claim compensation from insurance companies or to reimburse medical claims 
      BDMS needs to disclose your personal data to insurance companies to comply with a contract that you or BDMS makes with the insurance companies for compensation or medical reimbursement. Indeed, BDMS will not disclose your personal data to irrelevant parties.`,
          `– Identified data
    – Contact data
    – Health data`,
          `Once receipt of your intended consent for disclose of your personal data: health data to insurance companies for a right to claim compensation from the insurance companies or to reimburse medical claims (Section. 26)`,
        ],
        [
          "4.",
          `Disclose of the data to a party referring you for investigation or a payer when you give consent for disclose of personal data
In case of agency of either government, private sector or state enterprise refers you to the company for treatments or is a payer for your medical expenses, BDMS will disclose your health data which is sensitive personal data to aforementioned agency only if you give consent to disclose your data to the agency otherwise, BDMS will directly send you a result of investigation.`,
          `– Identified data
– Contact data
– Health data`,
          `Once receipt of your intended consent for disclose of your personal data (Section. 26)`,
        ],
        [
          "5.",
          `For purpose of linking electronic database of medical records among health providers via mobile application
      Once you give consent, BDMS will enter your personal data into computer system in a format of mobile application for your convenience to receive consultation via the application and for you to manage your data via the application. To maximize benefits, the system will link electronic database of medical records among network health providers for you to browse your existing personal data maintained in the providers via electronic devices as BDMS makes agreement with network health providers to protect your personal data in compliance with Personal Data Protection Act B.E. 2562.`,
          `– Identified data
    – Contact data
    – Health data`,
          `Once receipt of your intended consent for disclose of your personal data (Section. 26)`,
        ],
        [
          "6.",
          `For marketing purposes
      BDMS may collect, gather, use and analyse personal data for analysing your health condition and contacting you for communication, providing medical information and offering promotion, products and services according to your consent`,
          `– Identified data
    – Contact data
    – Data of subscribing and participating in marketing activities`,
          `BDMS will perform this activity after receiving your consent to BDMS to use your health data for marketing purposes (Section. 26)`,
        ],
      ],
    },
  },
  {
    title: "",
    header: "Definition",
    dtailList: `"Personal Data": information related to an individual that can be identifiable...
  "Sensitive Personal Data": includes data such as race, religion, health, etc.
  "Health data": includes treatment date, allergy history, diagnostic info, lab results, etc.
  "Process": includes collect, gather, use or disclose
  "Personal Data Controller": the authority deciding on personal data processing
  "Personal Data Processor": the executor under controller's instruction
  "Bangkok Dusit Medical Services Group": BDMS and its network
  "Network health provider": health providers under BDMS in Thailand and overseas`,
  },
  {
    title: "",
    header: "Personal Data BDMS Collects From You",
    dtailList: `Your personal data collected by BDMS can be classified as followings (detailed in context)`,
  },
  {
    key: "table-02",
    title: "",
    header: "",
    dtailList: ``,
    table: {
      title: ["Type of Personal data", "Details"],
      detail: [
        [
          "1. Personal data",
          "Such as name, surname, ID card number, face image, gender, date of birth, passport number or other identifiable numbers",
        ],
        [
          "2. Contact data",
          "Such as address, telephone number, e-mail address",
        ],
        [
          "3. Financial data",
          "Such as billing information, credit or debit information, receipt information, invoice information",
        ],
        [
          "4. Marketing Data",
          "Such as registration information used for subscribe and marketing participation",
        ],
        [
          "5. Technical data",
          "Such as IP Address of computer, type of browser, Cookies information time zone setting, operating system, platform and technology of devices used for accessing website and Online Appointment System",
        ],
        [
          "6. Health data",
          "such as treatment information, reports about physical or mental health condition, health cares of service receivers, laboratory test results, diagnosis, diagnostic disease, information about drug use and drug allergy, history of food allergy, blood result, laboratory result, pathological result, radiological images and radiological report, list of prescribed medication, necessary information for medical services, information of feedback and treatments",
        ],
      ],
    },
  },
  {
    title: "",
    header: "Sources Of Personal Data",
    dtailList: `1. Personal data directly collected from you such as:
      • Registration for medical services via various channels
  2. Personal data indirectly collected from:
      • Relatives or spouse
      • Authorized representatives
      • Network health providers (with your consent)
      • Referring agency or payer of services`,
  },
  {
    title: "",
    header: "Disclose Or Share Of Personal Data",
    dtailList: `BDMS will not disclose your personal data to outsiders except when laws permit, including:
  1. Government agencies or courts
  2. Contractual parties (under legal protection), including:
      • BDMS network health providers
      • Insurance companies or claim handlers
      • Referred hospitals
      • Referrers or payers
      • Outsourced data processors (labs, IT, telecoms, payment, etc.)
  3. Use of Cloud Computing (in Thailand or overseas) with contracts ensuring data security`,
  },
  {
    title: "",
    header: "Duration Of Personal Data Retention",
    dtailList: `1. Medical records kept for minimum 5 years, extended to 10 years if no contact, then destroyed
  2. Longer retention allowed for legal compliance or dispute resolution until the end of the case`,
  },
  {
    title: "",
    header: "Measures Of Personal Data Retention And Analysis",
    dtailList: `1. Use of SSL, firewall, passwords, and encrypted systems
  2. Limit access to authorized personnel and require confidentiality
  3. Prevent unauthorized system access
  4. Destroy unnecessary personal data
  5. For sensitive data: use of access controls, backups, emergency plans, and regular risk assessment`,
  },
  {
    title: "",
    header: "Overseas Transfer Of Personal Data",
    dtailList: `1. BDMS may transfer data overseas with consent and notify protection level
  2. Consent may be skipped if required by contract or urgent legal grounds`,
  },
  {
    title: "",
    header: "Cookie Policy",
    dtailList: `BDMS uses cookies to enhance website experience. Cookies store unique visit identifiers. May be used for analytics or marketing by third parties using IP address and cookie data. Users can control cookie permissions upon visit`,
  },
  {
    title: "",
    header: "Rights Of Personal Data Owner",
    dtailList: `1. Withdraw consent
  2. Access data
  3. Correct data
  4. Erase data
  5. Restrict processing
  6. Data portability
  7. Object to processing
  
  Contact Dr. Wisut Lachasewee – DPO Gr.1 at BDMS: Tel 02-310-3331, Email dpogroup1@bdms.co.th or dpogroup1@bangkokhospital.com`,
  },
  {
    title: "",
    header: "Changes Of Personal Data Protection Policy",
    dtailList: `BDMS may revise this policy and will inform users upon changes for better data protection`,
  },
  {
    title: "",
    header: "Contact Channels",
    dtailList: `Dr. Wisut Lachasewee – DPO Group 1  
  Email: dpogroup1@bdms.co.th or dpogroup1@bangkokhospital.com  
  Bangkok Dusit Medical Services Public Company Limited  
  2 Soi Soonvijai 7, New Petchaburi Rd, Bangkapi, Huaykwang, Bangkok  
  Phone: 02-310-3331`,
  },
];
